import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ShopSettings, ShopSettingsRepository } from '@infrab4a/connect';
import { MessageService, PrimeNGConfig } from 'primeng/api';
import { FileUpload } from 'primeng/fileupload';
import { FileControllerService } from 'src/app/admin-api';
import { CustomizationFormComponent } from 'src/app/components/customization/customization-form.component';
import { ImageService } from 'src/app/services/image.service';

@Component({
  selector: 'app-wishlist-banners-form',
  templateUrl: './wishlist-banners-form.component.html',
  styleUrls: ['./wishlist-banners-form.component.scss']
})
export class WishlistBannersFormComponent
  extends CustomizationFormComponent
  implements OnInit
{
  pageDocument: ShopSettings;

  constructor(
    @Inject('ShopSettingsRepository')
    private shopSettingsRepository: ShopSettingsRepository,
    private formBuilder: FormBuilder,
    private messageService: MessageService,
    private activatedRoute: ActivatedRoute,
    override router: Router,
    override imageService: ImageService,
    override config: PrimeNGConfig,
    override fileService: FileControllerService
  ) {
    super(router, config, imageService, fileService);

    this.documentId = 'WISHLIST_BANNERS';

    this.form = this.formBuilder.group({
      image: ['', [Validators.required]],
      title: ['', [Validators.required]],
      beginDate: [null, [Validators.required]],
      endDate: [null],
      hasMultiples: true
    });
  }

  async ngOnInit() {
    await this.getDocument();
  }

  override async getDocument(): Promise<void> {
    try {
      this.pageDocument = await this.shopSettingsRepository.get({
        id: this.documentId
      });
      this.documentSections = this.pageDocument.sections || [];
      if (this.router.url.includes('edit')) {
        this.activatedRoute.params.subscribe((params) => {
          this.activeIndex = +params['index'];
          this.activeSection = this.documentSections[this.activeIndex];
          this.initializeForm();
        });
      }
    } catch (error) {
      this.form.patchValue(this.activeSection);
    }
  }

  override initializeForm(): void {
    this.form.patchValue(this.activeSection);
  }

  override async save() {
    if (this.form.valid) {
      const doc = this.form.value;

      if (
        doc.beginDate <= this.today &&
        (!doc.endDate || this.today <= new Date(doc.endDate))
      ) {
        doc.active = true;
      } else {
        doc.active = false;
      }

      if (this.activeSection) this.documentSections[this.activeIndex] = doc;
      else this.documentSections.push(doc);

      await this.shopSettingsRepository.update({
        id: this.documentId,
        sections: this.documentSections
      });

      this.messageService.add({
        severity: 'success',
        summary: 'Salvo com sucesso',
        detail: 'As informações foram salvas.'
      });
      await this.afterSubmit();
      this.navigate('/configuracoes/wishlist/banners');
    } else {
      console.error('Formulário inválido. Não é possível salvar os dados.');
    }
  }

  isBeginDateInvalid() {
    const beginDateControl = this.form.get('beginDate');
    return (
      beginDateControl?.invalid &&
      (beginDateControl?.touched || beginDateControl?.dirty)
    );
  }

  isEndDateInvalid() {
    const beginDateControl = this.form.get('beginDate');
    const endDateControl = this.form.get('endDate');

    if (!endDateControl.value) return false;

    if (!beginDateControl.value) return true;

    if (
      new Date(endDateControl.value).setSeconds(0) <=
      new Date(beginDateControl.value).setSeconds(0)
    )
      return true;

    return (
      endDateControl?.invalid &&
      (endDateControl?.touched || endDateControl?.dirty)
    );
  }

  isTitleInvalid() {
    const titleControl = this.form.get('title');
    return (
      titleControl?.invalid && (titleControl?.touched || titleControl?.dirty)
    );
  }

  async handleFileSelect(
    event: { files: File[] },
    inputName: string,
    expectedWidth: number,
    expectedHeight: number,
    maxWeight: number,
    pInput: FileUpload
  ) {
    this.fileNamePattern = `glampoints-wishlist-banners-${new Date().getTime()}.webp`;

    await this.upload(
      event,
      inputName,
      expectedWidth,
      expectedHeight,
      maxWeight,
      pInput
    );
  }

  goToMenu() {
    this.navigate('configuracoes/wishlist/banners');
  }

  get bannerUrl(): string {
    return this.form.get('image')?.value;
  }
  override get filePath(): string {
    return '/pages/wishlist-banners/';
  }

  override get model() {
    return this.pageDocument;
  }

  override get modelId() {
    return this.pageDocument?.id;
  }
}
